export default __webpack_public_path__ + "static/media/tcs comm.e777fe37.png";